import { MailAiPagina } from '@/features/mail-ai/MailAiPagina';

/* /crm/mail-en-ai. De pagina zelf staat in src/features/mail-ai. */
export default function CRMMailAi() {
  return <MailAiPagina />;
}
